import { z } from "zod";
import { TovVersionStatusSchema } from "../../enums/tov";
import { TovChannelResponseSchema } from "./channels.responses";
import {
  TovAudienceResponseSchema,
  TovContentPillarResponseSchema,
  TovExampleResponseSchema,
  TovJourneyStageResponseSchema,
  TovLexiconResponseSchema,
  TovRevisionEventResponseSchema,
  TovRuleResponseSchema,
  TovToneDimensionResponseSchema,
  TovTraitResponseSchema,
  TovVisualGuidelineResponseSchema,
} from "./definitions.responses";

// The full TOV Version read: scalars plus every definition group. Every TOV
// write endpoint returns this shape, so the Admin panel and seeds always see the
// whole version after a change. Assembled here to keep responses.ts small.
// Lightweight Version row for the history switcher: scalars only, no nested
// definitions. The full Version (TovVersionResponse) is loaded on selection.
export const TovVersionSummaryResponseSchema = z.object({
  id: z.uuid(),
  profileId: z.uuid(),
  status: TovVersionStatusSchema,
  label: z.string(),
  summary: z.string(),
  createdAt: z.iso.datetime(),
  activatedAt: z.iso.datetime().nullable(),
  archivedAt: z.iso.datetime().nullable(),
});
export type TovVersionSummaryResponse = z.infer<
  typeof TovVersionSummaryResponseSchema
>;

export const TovVersionListResponseSchema = z.object({
  versions: z.array(TovVersionSummaryResponseSchema),
});
export type TovVersionListResponse = z.infer<
  typeof TovVersionListResponseSchema
>;

export const TovVersionResponseSchema = z.object({
  id: z.uuid(),
  profileId: z.uuid(),
  status: TovVersionStatusSchema,
  label: z.string(),
  summary: z.string(),
  createdAt: z.iso.datetime(),
  activatedAt: z.iso.datetime().nullable(),
  archivedAt: z.iso.datetime().nullable(),
  traits: z.array(TovTraitResponseSchema),
  toneDimensions: z.array(TovToneDimensionResponseSchema),
  rules: z.array(TovRuleResponseSchema),
  lexicon: z.array(TovLexiconResponseSchema),
  examples: z.array(TovExampleResponseSchema),
  audiences: z.array(TovAudienceResponseSchema),
  contentPillars: z.array(TovContentPillarResponseSchema),
  journeyStages: z.array(TovJourneyStageResponseSchema),
  channels: z.array(TovChannelResponseSchema),
  visualGuidelines: z.array(TovVisualGuidelineResponseSchema),
  revisionEvents: z.array(TovRevisionEventResponseSchema),
});
export type TovVersionResponse = z.infer<typeof TovVersionResponseSchema>;
